import type { PagedResultDto } from "@services/dto/pagedResultDto"
import customerSourceService from "@services/master-data/customerSourceService"
import { action, makeAutoObservable, observable } from "mobx"
import { appDataStoreInstance as appDataStore } from "../appDataStore"

class CustomerSourceStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable listData!: any
  @observable detailData!: any

  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
    this.listData = []
  }

  @action
  async createOrUpdate(body: any) {
    const result = await customerSourceService.createOrUpdate(body)
    this.detailData = result
    if (!body.id) {
      this.tableData.items.push(result)
    } else {
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
    appDataStore.getListSource()
  }

  @action
  async emptyDetail() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async active(id: number, isActive) {
    await customerSourceService.activate(id, isActive)
    appDataStore.getListSource()
  }

  @action
  async get(id: number) {
    const result = await customerSourceService.get(id)
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await customerSourceService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
  @action
  async getList(params: any) {
    this.isLoading = true
    const result = await customerSourceService
      .getList(params)
      .finally(() => (this.isLoading = false))
    this.listData = result
  }
}

export default CustomerSourceStore
